import React from 'react';
import { createPortal } from 'react-dom';
import { MapPin, X } from '@phosphor-icons/react';
import GenericMap from './GenericMap.jsx';

const DEFAULT_CENTER = [-31.5375, -68.5364];

/**
 * Selector de ubicación compartido por los formularios que usan coordenadas.
 * Mantiene el flujo existente: doble click para colocar el pin y confirmacion
 * explicita con "Usar esta ubicacion".
 */
const LocationPickerModal = ({
  open,
  coordinates,
  onCoordinatesChange,
  onConfirm,
  onClose,
  normalizeCoordinates,
  markerId = 'selected-location',
  minZoom,
  maxZoom = 18,
  maxBounds,
}) => {
  if (!open || typeof document === 'undefined') return null;

  const selected = normalizeCoordinates?.(coordinates?.lat, coordinates?.lng);
  const center = selected ? [Number(selected.lat), Number(selected.lng)] : DEFAULT_CENTER;

  return createPortal(
    <div className="fixed inset-0 bg-[var(--app-overlay)] flex items-center justify-center z-[10030] p-4 sm:p-6">
      <div className="bg-surface rounded-xl shadow-2xl overflow-hidden w-full max-w-4xl h-[70vh] sm:h-[80vh] relative border border-line">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 z-[1000] bg-bg/80 hover:bg-surface text-content-muted hover:text-content rounded-full p-2 transition-colors shadow-lg border border-line flex items-center justify-center"
          title="Cerrar mapa"
        >
          <X size={20} weight="bold" />
        </button>

        <GenericMap
          center={center}
          zoom={13}
          style={{ height: '100%', width: '100%' }}
          className="w-full h-full"
          {...(minZoom !== undefined ? { minZoom } : {})}
          maxZoom={maxZoom}
          {...(maxBounds ? { maxBounds } : {})}
          onMapDoubleClick={(latlng) => {
            const normalized = normalizeCoordinates?.(latlng.lat, latlng.lng);
            if (normalized) onCoordinatesChange(normalized);
          }}
          markers={selected ? [{ id: markerId, position: [selected.lat, selected.lng] }] : []}
        />

        <div className="absolute top-4 left-16 z-[1000] rounded-lg bg-bg/80 px-3 py-2 text-xs text-content border border-line shadow-lg pointer-events-none">
          Doble click en el mapa para colocar el pin
        </div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-[1000]">
          <button
            type="button"
            className="bg-green-600 hover:bg-green-500 text-white px-6 py-2.5 rounded-full shadow-lg font-semibold flex items-center gap-2 transition-colors border border-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2 focus:ring-offset-gray-800"
            onClick={() => {
              if (selected) onConfirm(selected);
              else onClose();
            }}
          >
            <MapPin size={20} />
            Usar esta ubicación
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LocationPickerModal;
